/* eslint-env browser */
import { CONFIG } from '../config/config';

const API_BASE = CONFIG.API_URL.replace(/\/$/, '');

function toUrl(input) {
  if (typeof input !== 'string') return input;
  if (/^https?:\/\//i.test(input)) return input;

  const base = (API_BASE || '/api').replace(/\/+$/, '');
  let path = input.startsWith('/') ? input : `/${input}`;

  // Evite les doublons quand base se termine par /api et path commence déjà par /api
  if (base.endsWith('/api') && path.startsWith('/api/')) {
    path = path.slice(4); // retire le premier '/api'
  }

  return `${base}${path}`;
}


function getToken() {
  return localStorage.getItem('token') || sessionStorage.getItem('token');
}

export function clearAuthAndRedirect() {
  [localStorage, sessionStorage].forEach((s) => {
    s.removeItem('token');
    s.removeItem('user');
    s.removeItem('role');
  });
  if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
}

export async function apiFetch(input, init = {}) {
  const urlStr = typeof input === 'string' ? input : input?.url ? String(input.url) : '';
  const isAuthLogin = urlStr.includes('/auth/login');

  const headers = new Headers(init.headers || (typeof input !== 'string' && input?.headers) || {});

  const token = getToken();
  if (token && !headers.has('Authorization') && !isAuthLogin) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  if (!headers.has('Content-Type') && !(init.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json');
  }

  const finalInit = { ...init, headers };

  const baseFetch =
    typeof window !== 'undefined' && window.__FETCH_ORIGINAL__
      ? window.__FETCH_ORIGINAL__
      : typeof window !== 'undefined' && window.fetch && window.fetch.__ORIGINAL__
        ? window.fetch.__ORIGINAL__
        : typeof window !== 'undefined' && window.fetch
          ? window.fetch
          : fetch;

  const res = await baseFetch(toUrl(input), finalInit);
  if (res.status === 401) {
    try {
      await res.clone().json();
    } catch {}
    clearAuthAndRedirect();
  }
  return res;
}

// Expose utilitaires si besoin dans les composants / autres APIs
export { getToken, toUrl, API_BASE };
